module.exports = __webpack_public_path__ + "static/pegframe-ddfc12923178a8ea128a1580c1b86ce4.jpeg";